import { render, staticRenderFns } from "./zsbToStudy.vue?vue&type=template&id=7f88bdfb&scoped=true&"
import script from "./zsbToStudy.vue?vue&type=script&lang=js&"
export * from "./zsbToStudy.vue?vue&type=script&lang=js&"
import style0 from "./zsbToStudy.vue?vue&type=style&index=0&id=7f88bdfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f88bdfb",
  null
  
)

export default component.exports